module.exports = __webpack_public_path__ + "img/product-1.2c1924ed.jpg";